<template>
  <div class="lesson-item py-4">
    <component
      class="text-decoration-none align-items-center"
      :is="isBlocked ? 'div' : 'router-link'"
      :to="routeInfo"
    >
      <lesson-thumb :item="item" :is-quiz="isQuiz" :isBlocked="isBlocked" />

      <div class="d-flex align-items-start">
        <h6 class="title flex-fill mb-0">{{ title }}</h6>
        <div
          v-if="item.progress && item.progress.finished_at"
          class="circle check no-borders"
        >
          <i class="icon-check no-borders" />
        </div>
      </div>
      <span v-if="item.description" class="description flex-fill">
        <div v-html="description"></div>
      </span>
      <div v-if="!isQuiz" class="icon-container">
        <button
          v-if="!item.is_favorite"
          @click.prevent="addToList(item)"
          class="button-overlay"
          title="Adicionar à minha lista"
        >
          <i class="icon-plus" />
        </button>
        <button
          v-else
          @click.prevent="removeFromList(item)"
          class="button-overlay"
          title="Remover da minha lista"
        >
          <i class="icon-check" />
        </button>
      </div>
    </component>
  </div>
</template>

<script>
import LessonThumb from "@/components/LessonThumb";
import { removeTimeZone } from "@/functions/helpers";

export default {
  components: { LessonThumb },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    description() {
      if (this.item.description)
        return this.item.description.replace(/(<([^>]+)>)/gi, " ");
      return "";
    },
    isQuiz() {
      return [
        "approval_average",
        "time_limit_minutes",
        "number_of_attempts"
      ].reduce((acc, cur) => acc && Object.keys(this.item).includes(cur), true);
    },
    isBlocked() {
      const isReleased = this.item.release_at
        ? new Date(removeTimeZone(this.item.release_at)).getTime() <
          new Date().getTime()
        : true;
      return this.item.is_blocked || !isReleased;
    },
    routeInfo() {
      if (this.isQuiz) {
        return {
          name: "lesson-quiz",
          params: {
            quiz: this.item.code,
            id: this.$route.params.id
          }
        };
      }

      return {
        name: "lesson",
        params: { lesson: this.item.id, id: this.item.module.id }
      };
    },
    title() {
      if (this.isQuiz) return this.item.title;
      return this.item.name;
    }
  },
  methods: {
    addToList(item) {
      this.$store
        .dispatch("lessons/addFavorite", {
          lesson_id: item.id,
          module_id: item.module.id
        })
        .then(() => {
          item.is_favorite = true;
          this.$message.success("Aula adicionada a minha lista.");
          this.$emit("update-my-list");
        })
        .catch(() => this.$message.error("Erro ao adicionar aula à lista"));
    },
    removeFromList(item) {
      this.$store
        .dispatch("lessons/removeFavorite", item.id)
        .then(() => {
          item.is_favorite = false;
          this.$message.success("Aula removida da minha lista.");
          this.$emit("update-my-list");
        })
        .catch(() => this.$message.error("Erro ao remover aula da lista"));
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson-item {
  width: 100%;
  height: 100%;
  position: relative;
  &:hover {
    .button-overlay {
      opacity: 1;
    }
  }
}

.button-overlay {
  opacity: 0;
  width: 24px;
  height: 24px;
  border: none;
  display: flex;
  align-items: center;
  border-radius: 100px;
  transition: all 0.2s;
  justify-content: center;
  background: rgba(223, 225, 232, 0.75);

  i {
    color: var(--verso-dark-roxo, #6b3ead);
    font-weight: bold;
    font-size: 18px;
  }
}

.icon-container {
  position: absolute;
  right: 8px;
  top: 32px;
}

a {
  display: block;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

.circle {
  display: flex;
  position: relative;
  min-width: 16px;
  min-height: 16px;
  border-radius: 24px;
  align-items: center;
  justify-content: center;

  i {
    color: #fff;
    font-size: 16px !important;
  }

  &::before {
    content: "Aula concluída";
    display: flex;
    position: absolute;
    align-items: center;
    justify-content: center;
    right: 0;
    top: 28px;
    width: 122px;
    height: 32px;
    font-size: 12px;
    border-radius: 4px;
    color: rgba(255, 255, 255, 1);
    background: rgba(37, 32, 52, 1);

    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }
}

.check {
  background: #62ad3e;
}

.title {
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.description {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}
</style>
